export const getIntersection = (arr1, arr2) =>
  arr1.filter(item => arr2.includes(item))

export const getDifferencesList = (arr1, arr2, key) => [
  ...arr1.filter(item1 => !arr2.find(item2 => item1[key] === item2[key])),
  ...arr2.filter(item1 => !arr1.find(item2 => item1[key] === item2[key]))
]
